var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8289 19.7776C19.9109 19.7589 21.7883 19.7183 22.8667 19.6484C21.24 22.0977 18.8091 23.7365 16.0967 24.4836C17.4055 23.2928 18.2889 21.4557 18.8289 19.7776Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17057 19.7776C7.71448 21.4679 8.59946 23.2977 9.90279 24.4836C7.20002 23.7392 4.76486 22.1057 3.13281 19.6484C4.21081 19.7182 6.08766 19.7589 7.17057 19.7776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0164 19.79C17.3031 21.8899 15.8658 24.5462 13.6897 24.8891C13.2232 24.9181 12.7786 24.9181 12.3121 24.8891C10.1364 24.5462 8.69948 21.8921 7.98535 19.79C11.1035 19.8338 14.8198 19.8349 18.0164 19.79Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90263 1.49707C8.59376 2.68804 7.71052 4.52505 7.17057 6.20313C6.09035 6.22183 4.21177 6.26239 3.13281 6.33227C4.75948 3.88298 7.19005 2.24436 9.90263 1.49707Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94101 6.97656C5.92302 10.7037 5.90624 15.2167 6.94101 19.0048C6.21136 18.9914 3.32381 18.9362 2.63359 18.8282C0.643057 15.2473 0.51369 10.9669 2.63359 7.15309C3.3254 7.04486 6.2405 6.9894 6.94101 6.97656Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2566 6.96256C19.3268 10.697 19.3279 15.2794 18.2566 19.0174C14.9803 19.0664 11.0231 19.0666 7.74255 19.0174C6.67231 15.2831 6.6712 10.7006 7.74255 6.96256C11.0255 6.91344 14.9833 6.9136 18.2566 6.96256Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.366 7.15309C25.3564 10.7339 25.4859 15.0144 23.366 18.8282C22.6761 18.9362 19.7762 18.9917 19.0586 19.0048C20.0722 15.2944 20.0976 10.7804 19.0586 6.97656C19.7848 6.98987 22.6755 7.04518 23.366 7.15309Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8667 6.33227C21.7877 6.26239 19.909 6.22167 18.8289 6.20313C18.2888 4.52426 17.4052 2.68773 16.0967 1.49707C18.7994 2.24151 21.2346 3.87506 22.8667 6.33227Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6895 1.09108C15.8656 1.43383 17.3024 4.08849 18.0164 6.19012C14.8872 6.14623 11.1681 6.14544 7.98535 6.19012C8.6979 4.09276 10.1344 1.43399 12.3124 1.09108C12.7768 1.06225 13.2213 1.06193 13.6895 1.09108Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.489c906f.svg";
export { ForwardRef as ReactComponent };